import React from "react";
import { Link, useLocation } from "react-router-dom";

import { AppPage } from "../components/common/appShell";

export default function NotFoundPage({
  title = "Page not found",
  description = "The page you requested does not exist or is no longer available.",
  homePath = "/devices",
  homeLabel = "Go to devices",
  history,
  location: providedLocation,
}) {
  const routerLocation = useLocation();
  const location = providedLocation || routerLocation;
  const requestedPath = [location?.pathname, location?.search]
    .filter(Boolean)
    .join("");

  const goBack = () => {
    if (history && typeof history.goBack === "function") {
      history.goBack();
      return;
    }
    window.history.back();
  };

  return (
    <AppPage narrow className="not-found-page">
      <section className="app-empty-state not-found-page__panel">
        <span className="not-found-page__code">404</span>
        <h2 className="not-found-page__title">{title}</h2>
        <p className="not-found-page__description">{description}</p>
        {requestedPath ? (
          <code className="not-found-page__path">{requestedPath}</code>
        ) : null}
        <div className="not-found-page__actions">
          <Link className="button" to={homePath}>
            {homeLabel}
          </Link>
          <button type="button" className="button secondary" onClick={goBack}>
            Go back
          </button>
        </div>
      </section>
    </AppPage>
  );
}
